import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import './index.css';

import 'src/assets/themes/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import { OpenAPI } from './apis/api-client';
import { loadTranslation, setupLanguageHeader } from './shared';

import './shared/i18n/i18n';

export * from './shared';

// Initialize the language header.
setupLanguageHeader();

// Loading the API URL from the environment variable.
OpenAPI.BASE = process.env.REACT_APP_API_URL ?? '';

// Initially load translations.
loadTranslation();

// Render the application.
const root =
  ReactDOM
    .createRoot(document.getElementById('root')!);

// Render the root.
root.render(
  <App />
);